import * as React from 'react';
import * as _ from 'lodash';
import * as styles from './common.module.scss';
import { MenuItem, ListItemText, FormControl, InputLabel, Select, OutlinedInput } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import useMeasuredRef from '../../hooks/useMeasuredRef';
import { fontFamilies } from '../../theme/text';

interface Props {
  values: any[];
  selectedValue: any;
  title: string;
  handleChange: (item: any) => void;
}

const StyledFormControl = withStyles(theme => ({
  root: {
    width: '100%',
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#00AAFC'
    },
    '& .MuiOutlinedInput-input': {
      paddingTop: 0,
      paddingBottom: 0
    },
    '& .MuiOutlinedInput-root': {
      height: 40
    },
    '& .MuiInputLabel-outlined': {
      transform: 'translate(14px, 13px) scale(1)'
    },
    '& .MuiTypography-body1': {
      fontFamily: fontFamilies.body,
      fontWeight: 200,
      fontSize: 14,
      letterSpacing: '0.2px',
      color: '#000000'
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      fontSize: 11,
      backgroundColor: 'white',
      transform: 'translate(14px, -6px) scale(1) !important'
    },
    '& .MuiSelect-select:focus': {
      backgroundColor: 'white'
    }
  }
}))(FormControl);

const StyledMenuItem = withStyles(theme => ({
  root: {
    '& .MuiTypography-body1': {
      fontFamily: fontFamilies.body,
      fontWeight: 200,
      fontSize: 14,
      letterSpacing: '0.2px',
      color: '#000000'
    },
    '& .MuiListItem-button:hover': {
      backgroundColor: '#eaf3f8'
    },
    '& .MuiTypograph': {
      body1: {
        color: 'black !important',
        fontFamily: fontFamilies.body,
        fontWeight: 200,
        fontSize: 14,
        letterSpacing: '0.2px'
      }
    },
    '.MuiButtonBase-root.Mui-disabled': {
      fontWeight: '600 !important',
      color: 'black !important'
    }
  },
  selected: {
    backgroundColor: '#eaf3f8 !important',
    color: 'black'
  }
}))(MenuItem);

const OutlinedDropdown = ({ values, selectedValue, title, handleChange: handleClick }: Props) => {
  const { measuredRef, dimensions } = useMeasuredRef([]);

  const renderMenuItems = () => {
    const valuesCopy = [...values];
    let formattedValues = [];
    valuesCopy.forEach(val => {
      if (!formattedValues.find(item => val.group && item.name === val.group.name)) {
        val.group && formattedValues.push(val.group);
      }
      val && formattedValues.push(val);
    });
    let updatedOptions = formattedValues.map(item => item.text || item.name);

    return formattedValues.map((item, index) => {
      return (
        <StyledMenuItem
          key={`menu-item-${index}`}
          disabled={!!item.name}
          value={item.value}
          selected={selectedValue === item}
          classes={{ root: !!item.name ? styles.disabledMenuItem : '' }}
        >
          <ListItemText primary={updatedOptions[index]} />
        </StyledMenuItem>
      );
    });
  };

  return (
    <StyledFormControl variant="outlined">
      <InputLabel shrink={true} ref={measuredRef} htmlFor="outlined-input">
        {title}
      </InputLabel>
      <Select
        value={selectedValue !== null ? selectedValue : ''}
        onChange={item => handleClick(item.target.value)}
        labelWidth={dimensions ? dimensions.width + 5 : 0}
        input={<OutlinedInput notched labelWidth={dimensions ? dimensions.width + 10 : 0} id="outlined-input" />}
      >
        {renderMenuItems()}
      </Select>
    </StyledFormControl>
  );
};

export default OutlinedDropdown;
